const getCitySelected = (store) => {
	return store.Session?.selectedCity;
};

export default getCitySelected;
